import { CaloriesResponse } from "@/clients/models/CaloriesResponse";
import { NutritionalRequirementsService } from "@/clients/services/NutritionalRequirementsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

interface UseGetCaloriesOptions {
  enabled?: boolean;
}

export const useGetCalories = (options?: UseGetCaloriesOptions) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT, "calories"],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const response =
        await NutritionalRequirementsService.getCaloriesApiV1NutritionalRequirementsCaloriesGet(
          user.id,
        );
      return response.data;
    },
    enabled: options?.enabled ?? true,
    staleTime: 0,
  });

  return {
    calories: data as CaloriesResponse | undefined,
    isLoading,
    error,
  };
};
